import React, { FC } from "react";
import { Field } from "react-final-form";
import { AccordionEditor } from "./AccordionEditor";
import { CourseDetailType, ICourseComponentProps } from "../../../types";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { courseDetailsConfig } from "../../../constants";

const Accordions: FC<ICourseComponentProps> = ({ fieldsGroupName }) => {
  const [expanded, setExpanded] = React.useState<CourseDetailType>();

  const handleExpand = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  return (
    <div>
      <FieldsGroupLabel
        label="Course Details"
        className="fields-group-label-first"
      />
      {courseDetailsConfig.map((item) => (
        <Field
          key={item.type}
          isExpanded={expanded === item.type}
          isRequired={item.isRequired}
          onExpand={() => handleExpand(item)}
          title={item.name}
          type="text"
          name={`${fieldsGroupName}.details.type_${item.type}`}
          component={AccordionEditor}
        />
      ))}
    </div>
  );
};

export default React.memo(Accordions);
